export interface Application {
    id: string;
    group_id: string;
    name: string;
}
